import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/encryption.service';

@Component({
  selector: 'app-visitor-proofid',
  templateUrl: './visitor-proofid.component.html',
  styleUrls: ['./visitor-proofid.component.scss']
})
export class VisitorProofidComponent implements OnInit {

  

  public webcamImage: any = null;
  Contact_No
  Link
  constructor(public appservice:AppService,private toastr: ToastrService,
    private encryptionService: EncryptionService, public router: Router, private http: HttpClient) { 
    
      var value = this.appservice.Company.replace("_","")+'-'+this.appservice.getItem("Barcode");
      this.Link = this.encryptionService.encryptToNumber(value);
      console.log(this.Link);
    this.Contact_No = this.appservice.getItem("Phone_Number");
  }


  take_photo()
  {
    this.appservice.Cam_Type = "Proof";    
    return this.router.navigate(['/visitor-camera']);
  }

  public add: any = {};
  public btndisable: boolean = false;
  addData() {

    this.add.Company = this.appservice.Company_;
    this.add.Company_ID = this.appservice.Company_;
    this.add.Created_by = this.appservice.CREATED_BY;
    this.add.Barcode = this.appservice.getItem("Barcode");
    this.add.V_Person_ID = this.appservice.getItem("V_Person_ID");
    this.add.Contact_No = this.Contact_No;
    this.add.link = this.Link;
    this.add.Status = "submit";
    try {
      this.add.Proff_image = this.appservice.Proof_Image;
    } catch {
      this.add.Proff_image = null;
    }
      this.btndisable = true;

      this.http.post(this.appservice.Server_URL + 'api/Visitor/Upload_Document', this.add, { headers: this.appservice.headers })
        .subscribe(
          (val: string) => {      

            if (val == "True") {
              this.btndisable = false;
             return this.router.navigate(['/visitor-thank-you']);
            }
            else {
              this.btndisable = false;
              this.toastr.error(val, "Error", { timeOut: 3000 });
            }
          },
          response => {
            this.toastr.error('Error ', response, {
              timeOut: 3000
            });

          });

  }

  ngOnInit(): void {
  }

}
